import Vue from 'vue'
import VueMask from 'vue-the-mask'

Vue.use(VueMask)
